import { useCallback, useState } from "react";

export const resolveVisibleWhen = (visibleWhen, form) => {
  if (typeof visibleWhen !== "function") return true;
  return !!visibleWhen(form || {});
};

export const useConfigFormState = (initial) => {
  const [form, setForm] = useState(initial);

  const setField = useCallback((key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  }, []);

  const setFields = useCallback((patch) => {
    setForm((prev) => ({ ...prev, ...patch }));
  }, []);

  const toggleMulti = useCallback((key, item) => {
    setForm((prev) => {
      const list = Array.isArray(prev[key]) ? prev[key] : [];
      return {
        ...prev,
        [key]: list.includes(item) ? list.filter((entry) => entry !== item) : [...list, item],
      };
    });
  }, []);

  return { form, setForm, setField, setFields, toggleMulti };
};
